import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledBetaTag = styled.div`
  background-color: ${colorsPalettes.mint[500]};
  padding: 4px 5px;
  border-radius: 16px;
  ${setFontVariant('tag', colorsPalettes.carbon[0])};
`;
